// Centralized enums/constants for the app. Database-agnostic shapes (PostgreSQL-ready).

export const CONTENT_STATUSES = [
  "inbox",
  "draft",
  "needs_review",
  "approved",
  "scheduled",
  "publishing",
  "published",
  "failed",
  "archived",
];

export const STATUS_LABELS = {
  inbox: "Inbox",
  draft: "Draft",
  needs_review: "Needs Review",
  approved: "Approved",
  scheduled: "Scheduled",
  publishing: "Publishing",
  published: "Published",
  failed: "Failed",
  archived: "Archived",
  reference: "Reference",
};

export const ASSET_TYPES = [
  "social_post",
  "thread",
  "blog",
  "video_script",
  "image_prompt",
  "carousel_outline",
  "research_brief",
  "execution_report",
  "manual_post",
  "imported_draft",
];

export const ASSET_TYPE_LABELS = {
  social_post: "Social Post",
  thread: "Thread",
  blog: "Blog",
  video_script: "Video Script",
  image_prompt: "Image Prompt",
  carousel_outline: "Carousel Outline",
  research_brief: "Research Brief",
  execution_report: "Execution Report",
  manual_post: "Manual Post",
  imported_draft: "Imported Draft",
};

export const AGENT_RUN_STATUSES = [
  "queued",
  "running",
  "waiting_for_clarification",
  "completed",
  "failed",
];

export const PLATFORMS = [
  "linkedin",
  "x",
  "facebook",
  "instagram",
  "youtube_shorts",
  "threads",
  "bluesky",
  "blog",
];

export const PLATFORM_LABELS = {
  linkedin: "LinkedIn",
  x: "X / Twitter",
  facebook: "Facebook",
  instagram: "Instagram",
  youtube_shorts: "YouTube Shorts",
  threads: "Threads",
  bluesky: "Bluesky",
  blog: "Blog",
};

export const SKILL_PHASES = [
  "research",
  "planning",
  "generation",
  "critique",
  "formatting",
];

export const SKILL_PHASE_LABELS = {
  research: "Research",
  planning: "Planning",
  generation: "Generation",
  critique: "Critique",
  formatting: "Formatting",
};

// Friendly skill categories surfaced in the UI (voice lives on the Brands page).
export const SKILL_CATEGORIES = ["style", "industry", "critique"];

export const SKILL_CATEGORY_LABELS = {
  style: "Style",
  industry: "Industry",
  critique: "Polish",
};

export const MODEL_PROVIDERS = [
  { id: "openai", label: "OpenAI", group: "Quality", hint: "GPT-class general purpose" },
  { id: "anthropic", label: "Anthropic", group: "Quality", hint: "Claude — long-context writing" },
  { id: "openrouter", label: "OpenRouter", group: "Quality", hint: "Router across many models" },
  { id: "gemini", label: "Gemini", group: "Quality", hint: "Google multi-modal" },
  { id: "ollama_cloud", label: "Ollama Cloud", group: "Local-style", hint: "Hosted local models" },
  { id: "ollama_local", label: "Ollama Local", group: "Local-style", hint: "Runs on your machine" },
];

export const GOALS = [
  { id: "authority", label: "Build Authority" },
  { id: "educate", label: "Educate" },
  { id: "leads", label: "Generate Leads" },
  { id: "promote", label: "Promote Offer" },
  { id: "repurpose", label: "Repurpose Existing" },
];

export const TONES = [
  { id: "adam_voice", label: "Adam Voice" },
  { id: "technical_explainer", label: "Technical Explainer" },
  { id: "small_business_trust", label: "Small Business Trust" },
  { id: "founder_build_in_public", label: "Founder Build-in-Public" },
];

export const CONTENT_TYPES = [
  { id: "agent_campaign", label: "Agent Campaign" },
  { id: "manual_post", label: "Manual Post" },
  { id: "blog_writer", label: "Blog Writer" },
  { id: "repurpose", label: "Repurpose" },
  { id: "research_brief", label: "Research Brief" },
  { id: "image_prompt", label: "Image Prompt" },
];

export const INGESTION_SOURCES = [
  "claude",
  "codex",
  "openclaw",
  "hermes",
  "n8n",
  "webhook",
  "mcp_server",
];
